import { useNavigate } from 'react-router';
import { formatEuro } from '@brimo/shared';
import { Button } from '../../../ds/components';
import type { FinancingRecord } from '../types';
import styles from './record.module.css';

/**
 * Tab „Selbstauskunft": the summary of the contact's latest signed version (`customerProfile`) and
 * „Selbstauskunft öffnen" (the internal page of the self-disclosure module).
 */
export function SelfDisclosureMain({ financing }: { financing: FinancingRecord }) {
  const navigate = useNavigate();
  const profile = financing.customerProfile;
  if (!profile) {
    return (
      <section className={styles.card} aria-label="Selbstauskunft">
        <h2 className={styles.cardTitle}>Selbstauskunft</h2>
        <p className={styles.cardText}>Zu diesem Kontakt liegt keine unterschriebene Selbstauskunft vor.</p>
      </section>
    );
  }
  const rows = [
    { label: 'Beschäftigung', value: profile.employment },
    {
      label: 'Haushaltsnetto',
      value: profile.householdNetCents === null ? null : `${formatEuro(profile.householdNetCents)} / Monat`,
    },
    { label: 'Eigenkapital', value: profile.equityCents === null ? null : formatEuro(profile.equityCents) },
    {
      label: 'Volumen',
      value:
        profile.volumeCents === null
          ? null
          : `${formatEuro(profile.volumeCents)}${profile.volumeTag ? ` · ${profile.volumeTag}` : ''}`,
    },
  ].filter((row): row is { label: string; value: string } => row.value !== null);
  return (
    <section className={styles.card} aria-label="Selbstauskunft">
      <h2 className={styles.cardTitle}>Selbstauskunft</h2>
      <p className={styles.cardText}>Stand der letzten unterschriebenen Version.</p>
      <div className={styles.profileGrid}>
        {rows.map((row) => (
          <div key={row.label} className={styles.kv}>
            <span className={styles.kvLabel}>{row.label}</span>
            <span className={styles.kvValue}>{row.value}</span>
          </div>
        ))}
      </div>
      <div className={styles.profileFoot}>
        <Button variant="secondary" onClick={() => void navigate(profile.selfDisclosureHref)}>
          Selbstauskunft öffnen
        </Button>
      </div>
    </section>
  );
}
